import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { gql } from "@apollo/client";
import { DateTime } from "luxon";
import { formattedPrice } from "@withfriendsco/wf-components";
gql `
fragment MembershipWithfriendsTransaction on Transaction {
    id
    time
    amount {
        amount
    }
    currencyCode
    paymentStatus
    kind
    receiptLink
}
`;
const MembershipWithfriendsTransaction = ({ withfriendsTransaction, membershipName }) => {
    var _a;
    const createdAt = DateTime.fromSQL(withfriendsTransaction.time);
    const customerMembershipTotal = formattedPrice(((_a = withfriendsTransaction.amount) === null || _a === void 0 ? void 0 : _a.amount) || 0, withfriendsTransaction.currencyCode);
    return (_jsx("div", { className: "leading-loose flex items-center", children: _jsxs("span", { children: [`${createdAt.toLocaleString()} - ${membershipName}${withfriendsTransaction.kind == 'Addon' ? ' (Addons)' : ''}: ${customerMembershipTotal} - ${withfriendsTransaction.paymentStatus}`, withfriendsTransaction.receiptLink && (_jsxs(_Fragment, { children: [_jsx("span", { className: "mx-2", children: "-" }), _jsx("a", { href: withfriendsTransaction.receiptLink, target: "_blank", rel: "noopener noreferrer", className: "text-wfGray-700 underline hover:text-wfGray-500", children: "Receipt" })] }))] }) }));
};
export default MembershipWithfriendsTransaction;
